<!--
  Generated template for the TextDataProtectPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-header>
	<ion-toolbar class="shadow">
      <ion-buttons slot="start" *ngIf="previousUrl">
        <ion-back-button [defaultHref]="previousUrl" (click)="navCtrl.back()"></ion-back-button>
      </ion-buttons>
      <ion-title>
        <!-- <div style="padding-top:15px;padding-bottom:15px;"> -->
          {{ 'SETTINGS_PRIVACY_POLICY_BTN' | translate}}
		<!-- </div> -->
      </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content padding>
	<h2>Datenschutzerklärung</h2>
	<p>Der Schutz deiner personenbezogenen Daten ist uns wichtig. Mit dieser Datenschutzerklärung möchten wir dir
		genauer erklären, welche personenbezogenen Daten wir im Rahmen deiner Nutzung der GOForest Tracking App erheben
		und zu welchem Zweck die Daten verwendet werden.</p>

	<p><b>Verantwortlicher und Kontakt</b><br />
		Verantwortlicher für die Verarbeitung deiner personenbezogenen Daten ist:
		(IT)² Interactive GmbH
		Joseph-von-Fraunhofer Str. 20, Technologiezentrum
		44227 Dortmund
		Wenn Du Fragen oder Anregungen zum Datenschutz hast, kannst du dich gerne auch per E-Mail an uns unter der
		Adresse info@it2in.de wenden.<br />
	</p>

	<p><b>Gegenstand des Datenschutzes</b><br />
		Gegenstand des Datenschutzes sind personenbezogene Daten (nachfolgend auch schlicht „Daten“ genannt), also alle
		Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen.<br />
		a. Registrierungsdaten: Wenn du ein GOForest Tracking App Profil anlegst, können wir die von dir bei diesem
		Prozess bereitgestellten Informationen, z. B. deinen vollen Namen, deine E-Mail-Adresse, deine Postleitzahl,
		deine Anschrift und sonstige Informationen, die du im Zusammenhang mit deinem Profil bereitstellst, wie etwa
		dein Geschlecht, deine Telefonnummer und dein Geburtsdatum, speichern und verwenden. Wir können deinen Vornamen
		und den ersten Buchstaben deines Nachnamens sowie Fotos oder andere Inhalte, die du bei der Registrierung
		übermittelst, als Teil deines Profils öffentlich anzeigen. Du kannst einige der mit deinem Konto verbundenen
		Informationen in deinen Kontoeinstellungen ändern. Wenn du glaubst, dass jemand ein unbefugtes Konto mit deinen
		Angaben oder Angaben, die deinen sehr ähnlich sind, erstellt hat, kannst du dessen Entfernung durch Meldung des
		entsprechenden Profils beantragen.
	</p>
	<p>
		b. Allgemeine Zugänglichkeit der Inhalte: Deine Inhalte für den Dienst sind für die Öffentlichkeit bestimmt und
		daher für die Öffentlichkeit sichtbar, einschließlich deiner Fotos, Bewertungen und Beiträge. Dein Profil (z. B.
		Vorname, erster Buchstabe des Nachnamens, Stadt, Nachbarschaft, Beitrittsmonat, Profilfotos und Freunde) ist
		auch für die Öffentlichkeit bestimmt.
	</p>
	<p>
		c. GPS Standortdaten: Nur mit Deiner vorherigen Zustimmung gelten folgende Bestimmungen: Mit der App kannst Du
		Dich im Hannover Marathon tracken lassen, als Teilnehmer wird Deine Strecke aufgezeichnet. Dazu müssen Daten zu
		Deinem Standort gesammelt werden. Mit dem Begriff „Standortinformationen“ beziehen wir uns auf die kombinierten
		Standortdaten Deines Telefons oder Geräts. Während das Tracking läuft, werden die Standortinformationen lokal
		auf Deinem Smartphone angezeigt, sofern Du die Ortungsdienste aktiviert und der App den Zugriff gewährt hast.
		Die Standortinformationen sind nicht für Dritte zugänglich und werden nicht auf dem Smartphone oder Server
		gespeichert.
	</p>
	<p>
		d. Rechtsgrundlage für die Verarbeitung: Für Personen, die ihren Wohnsitz ausschließlich im Europäischen
		Wirtschaftsraum (EWR) und in der Schweiz haben, hängt unsere Rechtsgrundlage für die Sammlung und Nutzung der
		oben genannten Informationen von den spezifischen Informationen und dem Kontext ab, in dem wir sie sammeln.
		Normalerweise sammeln wir personenbezogene Daten von dir jedoch nur, wenn wir dazu dein Einverständnis erhalten
		haben, wenn wir die personenbezogenen Daten benötigen, um einen Vertrag mit dir zu erfüllen, oder wenn die
		Bearbeitung in unserem berechtigten Interesse liegt und dies nicht durch deine Datenschutzinteressen oder
		Grundrechte und Freiheiten außer Kraft gesetzt wird. In einigen Fällen sind wir möglicherweise auch rechtlich
		verpflichtet, personenbezogene Daten von dir zu erfassen, oder wir benötigen die personenbezogenen Daten
		möglicherweise anderweitig, um deine wesentlichen Interessen oder die einer anderen Person zu schützen (z. B. um
		mögliches Fehlverhalten in Verbindung mit dem Dienst zu verhindern, zu untersuchen oder zu erkennen oder um
		gesetzliche Verpflichtungen einzuhalten). Wenn wir dich bitten, personenbezogene Daten zur Erfüllung
		gesetzlicher Vorschriften oder zur Kontaktaufnahme mit dir anzugeben, machen wir dies zum maßgeblichen Zeitpunkt
		deutlich, und wir weisen dich darauf hin, ob die Angabe deiner personenbezogenen Daten verpflichtend ist oder
		nicht (sowie die möglichen Folgen, wenn du deine persönlichen Daten nicht angibst). Wenn wir deine
		personenbezogenen Daten im Vertrauen auf unser berechtigtes Interesse (oder das Interesse von Dritten) sammeln
		und verwenden, besteht unser Interesse in der Regel darin, unsere Dienste zu betreiben, mit dir in Bezug auf
		unsere Dienste oder für unsere anderen berechtigten kommerziellen Interessen zu kommunizieren, z. B. bei der
		Beantwortung deiner Anfragen, bei der Analyse und Verbesserung unserer Plattform, beim Marketing oder bei der
		Aufdeckung oder Verhinderung von Betrug. Wenn du Fragen zu der Rechtsgrundlage hast, auf der wir deine
		persönlichen Daten erheben und verwenden, kontaktiere uns bitte unter der im Abschnitt „Kontakt“ weiter unten
		angegebenen Adresse. können wir im Rahmen von Nachforschungen, die sich auf die Nutzung des Dienstes beziehen,
		auf diese Nachrichten zugreifen und diese offenlegen. Wenn du deinen Wohnsitz im EWR oder in der Schweiz hast,
		hast du das Recht, deine personenbezogenen Daten abzurufen, zu berichtigen, zu aktualisieren oder um die
		Löschung deiner personenbezogenen Daten zu bitten. Du kannst der Verarbeitung deiner persönlichen Daten
		widersprechen, uns bitten, die Verarbeitung deiner persönlichen Daten einzuschränken oder die Übertragbarkeit
		deiner persönlichen Daten anfordern. Gleichermaßen kannst du deine Zustimmung jederzeit widerrufen, wenn wir
		deine persönlichen Daten mit deiner Zustimmung gesammelt und verarbeitet haben. Wenn du deine Zustimmung
		widerrufst, hat dies keinen Einfluss auf die Rechtmäßigkeit der Verarbeitung, die wir vor deinem Widerruf
		durchgeführt haben, noch auf die Verarbeitung deiner persönlichen Daten, die aus anderen rechtlich zulässigen
		Gründen als der Zustimmung durchgeführt wird. Außerdem hast du das Recht, dich von den Marketingmitteilungen
		abzumelden, die wir dir zusenden. Der Dienst bietet dir in der Regel eine angemessene Möglichkeit, deine
		Profilinformationen einzusehen und zu ändern, und du kannst die Marketingkommunikation jederzeit ablehnen, indem
		du in den Marketing-E-Mails, die wir dir zusenden, auf den Link „Abbestellen“ oder „Abmelden“ klickst. Wenn du
		jedoch Fragen oder Bedenken hinsichtlich der Verarbeitung deiner personenbezogenen Daten hast, kannst du uns wie
		im Abschnitt „Kontakt“ weiter unten beschrieben kontaktieren. Bitte nimm zur Kenntnis, dass die (IT)²
		Interactive GmbH als „Datenverantwortliche“ fungiert und somit die Verantwortung für den Schutz deiner
		personenbezogenen Daten in Bezug auf den Dienst trägt.
	</p>

	<p><b>Datenaufbewahrung und Schliessung des Userprofils</b><br />
		Du kannst dein Profil schließen, indem du deinen Benutzer in der App selbst löschst oder uns eine kurze
		Nachricht an info@spooorts.de zukommen läßt. Wir sorgen dann dafür, dass bestimmte öffentliche Beiträge nicht
		mehr zugänglich sind und/oder entfernen deren Verbindung zu deinem Userprofil, allerdings können wir deine Daten
		zu im Rahmen dieser Datenschutzerklärung autorisierten Zwecken aufbewahren, sofern dies nicht gesetzlich
		verboten ist. Wir können bspw. Daten aufbewahren, um mögliches Fehlverhalten in Verbindung mit dem Dienst zu
		verhindern, zu untersuchen oder zu erkennen oder um gesetzliche Verpflichtungen einzuhalten. Bitte beachte, dass
		Unternehmen ihre Einträge, Bewertungen oder Beiträge nicht durch die Schließung ihrer Konten entfernen können.
	</p>

	<p><b>Sicherheit</b><br />
		Wir setzen angemessene technische und organisatorische Sicherheitsmaßnahmen zum Schutz der uns übermittelten
		personenbezogenen Daten vor zufälliger oder unrechtmäßiger Zerstörung, Verlust, Veränderung und unberechtigter
		Offenlegung oder Zugriff ein, und zwar sowohl während ihrer Übermittlung als auch nach Erhalt. Verfahren zur
		Übermittlung von Daten über das Internet oder per Mobiltelefon und Verfahren der elektronischen Speicherung sind
		jedoch nie 100 % sicher. Daher können wir, auch wenn wir uns bemühen, deine personenbezogenen Daten mit
		wirtschaftlich zumutbaren Mitteln zu schützen, keine absolute Sicherheit für die Daten garantieren.
	</p>

	<p><b>IP Adressen in Google Services</b>
		IP Adressen in Google Services
		Wir verwenden das Cordova-plugin-admob-free-Plugin in der GOForest App. Dieses Plugin ermöglicht es uns, Werbung
		innerhalb unserer App anzuzeigen. Durch die Verwendung dieses Plug-ins stimmen Sie der Erfassung bestimmter
		Informationen, einschließlich anonymer Kennungen und IP-Adressen, durch den Plug-in-Anbieter zu. Diese
		Informationen können verwendet werden, um Ihnen gezielte Werbung zu liefern. Sie können der Verwendung dieses
		Plugins jederzeit widersprechen, indem Sie es in den Einstellungen Ihres Geräts deaktivieren.
	</p>

	<p><b>Änderungen an dieser Datenschutzerklärung</b><br />
		Wir sind berechtigt, diese Datenschutzerklärung gelegentlich zu ändern. Für unsere Nutzung, Erfassung und
		Weitergabe von Informationen über dich gilt die jeweils aktuelle Version der Datenschutzerklärung, die du hier
		nachlesen kannst. Wenn wir wesentliche Änderungen an dieser Datenschutzrichtlinie vornehmen, benachrichtigen wir
		dich hiervon vor dem Datum des Inkrafttretens der Änderungen per E-Mail oder durch Veröffentlichen einer
		Nachricht auf dem Dienst. Wenn du nach Wirksamwerden dieser Änderungen den Dienst weiterhin aufrufst oder
		benutzt, stimmst du der überarbeiteten Datenschutzerklärung zu.
	</p>

	<p><b>Internationale Datenübertragung</b><br />
		User, die ihren Wohnsitz im EWR oder in der Schweiz haben, werden darauf hingewiesen, dass die personenbezogenen
		Daten, die wir von ihnen bzw. über sie erfassen, für die in dieser Datenschutzerklärung beschriebenen Zwecke
		nach außerhalb des EWR oder der Schweiz übertragen, dort verarbeitet und aufbewahrt werden können,
		einschließlich der Vereinigten Staaten von Amerika. Wir nehmen den Schutz der Daten unserer User ernst und
		unternehmen deshalb Schritte, um ihre Informationen zu schützen, wozu u. a. die Gewährleistung eines adäquaten
		Datenschutzniveaus in Übereinstimmung mit EU-Normen gehört. Zu diesen Sicherheitsvorkehrungen gehört die
		Umsetzung der Standardvertragsklauseln der Europäischen Kommission für die Übermittlung persönlicher Daten
		zwischen unseren Konzerngesellschaften, die von allen Konzerngesellschaften verlangen, persönliche Daten aus dem
		EWR, die sie gemäß dem Datenschutzrecht der Europäischen Union verarbeiten, zu schützen. Wir haben ähnliche
		geeignete Sicherheitsmaßnahmen mit unseren Drittanbietern und Partnern implementiert, und weitere Details können
		auf Anfrage zur Verfügung gestellt werden.
	</p>

</ion-content>